import styles from "./hero.module.css"

import LenaMemoji from "../../images/Lena_MEMOJI_3.png";

export default function DesignerHero() {
  return (
    <section className={styles.hero}>
      {/* Left Content */}
      <div className={styles.leftContent}>
        <div className={styles.contentBlock}>
          {/* Main Headline */}
          <div>
            <h1 className={styles.mainHeadline}>I'm a UX/UI Designer</h1>
            <div className={styles.subheadlineContainer}>
              <p className={styles.subheadline}>crafting B2C mobile apps</p>
              <p className={styles.subheadline}>focused on personal finance.</p>
            </div>
          </div>

          {/* Body Text */}
          <div className={styles.bodyTextContainer}>
            <p className={styles.bodyText}>
              I design mobile products by learning from users and refining solutions through constant iteration. Working
              in PFM and health tech has helped me design interfaces that feel clear, simple, and trustworthy for
              everyday use.
            </p>

            <p className={styles.secondaryText}>Open to relocation within Europe and remote opportunities.</p>
          </div>
  
        </div>
      </div>

      {/* Right Side - Avatar Circle */}
      <div className={styles.rightContent}>
         <img src={LenaMemoji} width="305" height="305" />
        {/* <div className={styles.avatarCircle}> */}
           
          {/* <div className={styles.innerCircle}> */}
            {/* <span className={styles.lightbulb}>💡</span> */}
          {/* </div> */}
        {/* </div> */}
      </div>
    </section>
  )
}
